import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApihelperFunction } from "../../API/ApiHelperFunction";

const initialState = {
    status: '',
    data: '',
    error: false,
    loading: false,
    message: ''
}

export const WithdrawFundRequest = createAsyncThunk("/WithdrawFundRequest", async (withdrawFundTransactionReqData) => {
    let data = new FormData();
    for (const key in withdrawFundTransactionReqData) {
        if (withdrawFundTransactionReqData.hasOwnProperty(key)) {
                data.append(key, withdrawFundTransactionReqData[key]);
        }
    }
    console.log(data, withdrawFundTransactionReqData, 'withdrawFundTransactionReqData')
    const response = await ApihelperFunction({
        urlPath: "api/withdrawTransactionRequest",
        formData: data,
        method: "post",
        typeContent: true
    });
    return response;
});

const WithdrawFundRequestSlice = createSlice({
    name: "WithdrawFundRequest",
    initialState,
    reducers: {
        resetStateWithdrawFundRequest: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(WithdrawFundRequest.pending, (state) => {
                state.status = 'LOADING'
                state.loading = true
                state.error = false
                state.message = ''
            })
            .addCase(WithdrawFundRequest.fulfilled, (state, action) => {
                if (action?.payload?.status) {
                    state.loading = false
                    state.error = false
                    state.status = "SUCCESS"
                    state.message = action?.payload?.message
                }
                else {
                    state.loading = false
                    state.status = "ERROR"
                    state.error = [action?.payload?.errors]
                }
                state.data = action?.payload?.data;
            })
            .addCase(WithdrawFundRequest.rejected, (state, action) => {
                state.loading = false
                state.status = 'ERROR'
            })
    }
})

export const { resetStateWithdrawFundRequest } = WithdrawFundRequestSlice.actions;
export default WithdrawFundRequestSlice.reducer